import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = {
  linkUrl: string;
} & ComponentPropsWithoutRef<'li'>;

const FooterItem = forwardRef<HTMLLIElement, Props>(({ children, linkUrl, ...props }, ref) => {
  return (
    <li {...props} ref={ref}>
      <a href={linkUrl} className="link_policy" rel="noopener noreferrer" target="_blank">
        {children}
      </a>
    </li>
  );
});

FooterItem.displayName = 'FooterItem';

export default FooterItem;
